<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-title primary-title>
        <div>
          <h5 class="title mb-0">Recebimento no Posto (Pós-Pago)</h5>
        </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-flex>
      <v-data-table
        hide-actions
        :loading="loading"
        :items="tiposPagamentoPos"
        :hide-headers="!tiposPagamentoPos.length"
        class="elevation-1"
      >
        <template v-slot:headers>
          <tr>
            <th></th>
            <th class="text-xs-left">Descrição</th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr :ref="props.item.referencia">
            <td style="width: 10px">
              <v-tooltip lazy bottom>
                <template v-slot:activator="{ on }">
                  <v-switch v-on="on" v-model="props.item.aceito" readonly @click.stop="() => toogleTipoPagamentoPos(props.item.referencia)">
                  </v-switch>
                </template>
                Apagar
              </v-tooltip>
            </td>
            <td  class="text-xs-left" >{{ props.item.descricao }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-card>
</template>

<script>

export default {
  data () {
    return {
      tiposPagamentoPos: []
    }
  },
  mounted () {
    if (this.posto) {
      this.$store.dispatch('carregarTiposPos').then(this.carregarTipos)
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    toogleTipoPagamentoPos (referencia) {
      this.$store.dispatch('toogleTiposPos', referencia).then((aceito) => {
        this.tiposPagamentoPos = this.tiposPagamentoPos.map((tipo) => {
          if (tipo.referencia === referencia) {
            return { ...tipo, aceito: aceito }
          }
          return tipo
        })
      })
    },
    carregarTipos (tipos) {
      this.tiposPagamentoPos = tipos
    }
  },
  watch: {
    posto (val) {
      if (val) {
        this.$store.dispatch('carregarTiposPos').then(this.carregarTipos)
      }
    }
  }
}
</script>
